import { __extends } from "tslib";
import { PartitionBase } from '@awayjs/view';
import { SceneGraphNode } from './SceneGraphNode';
/**
 * @class away.partition.Partition
 */
var SceneGraphPartition = /** @class */ (function (_super) {
    __extends(SceneGraphPartition, _super);
    function SceneGraphPartition(root, isScene) {
        if (isScene === void 0) { isScene = false; }
        var _this = _super.call(this, root, isScene) || this;
        _this._rootNode = new SceneGraphNode(root, _this);
        return _this;
    }
    SceneGraphPartition.prototype.getPartition = function (entity) {
        //get a new partition for every displayobjectcontainer
        return new SceneGraphPartition(entity);
    };
    return SceneGraphPartition;
}(PartitionBase));
export { SceneGraphPartition };
